import './style.scss';
import {Box, FormControl, InputAdornment, OutlinedInput, Typography} from "@mui/material";
import InputAmountSlider from "../slider/InputAmountSlider";
import FormHelper from "../../../helpers/FormHelper";

function Amount({label, amount, purposeData, handler, className}) {
    purposeData = FormHelper.parsePurposeData(purposeData);
    const from = purposeData.lp_amount_from;
    const to = purposeData.lp_amount_to;
    const defaultValue = purposeData.lp_amount_default;
    const step = purposeData.lp_amount_step;
    const apr = purposeData.lp_apr;

    const handleSlide = (newValue) => {
        newValue = FormHelper.validateMinMax(from, to, newValue);
        handler(newValue);
    }

    return <>
        <Box className={className}>
            <Box className="calc-amount-head">
                {label && (<Typography variant="h6">{label}</Typography>)}
                <FormControl variant="outlined" className="calc-amount-input-wrapper">
                    <Box display="flex" className="calc-amount-input">
                        <Typography className="calc-amount-input-inner"
                                    variant="h4">
                            {FormHelper.moneyFormatter.format(amount).split('.')[0]}
                        </Typography>
                    </Box>

                </FormControl>
            </Box>
            <InputAmountSlider {...{value: amount, handler: handleSlide, from, to, defaultValue, step, apr}} />
        </Box>
    </>
}

export default Amount;